import {intersection, isArray} from 'lodash'
import {WidgetFlag} from './WidgetFlag'
import {observable} from 'mobx'

///////////////////////////////////////////////////////////////////////////////

export class Flags {
  @observable private flags: WidgetFlag[] = []

  has(flag: WidgetFlag | WidgetFlag[]): boolean {
    if (!isArray(flag)) {
      flag = [flag]
    }

    return intersection(this.flags, flag).length > 0
  }

  add(flag: WidgetFlag) {
    if (!this.has(flag)) {
      this.flags.push(flag)
    }
  }

  remove(flag: WidgetFlag) {
    if (this.has(flag)) {
      this.flags = this.flags.filter((v) => v !== flag)
    }
  }

  reset() {
    this.flags = []
  }

  toggle(flag: WidgetFlag) {
    if (!this.has(flag)) {
      this.add(flag)
    } else {
      this.remove(flag)
    }
  }
}

///////////////////////////////////////////////////////////////////////////////

export function createFlags(): Flags {
  return new Flags()
}
